import script from "./item-delete.vue?vue&type=script&setup=true&lang=js"
export * from "./item-delete.vue?vue&type=script&setup=true&lang=js"

import "./item-delete.vue?vue&type=style&index=0&id=5097a8b1&lang=scss"

const __exports__ = script;

export default __exports__